import { main, navigation, page } from './layoutBase.css';

type PageLayoutProps = React.PropsWithChildren<{
  menu: React.ReactNode;
}>;

export const LayoutBase = (p: PageLayoutProps) => (
  <div className={page}>
    <div className={navigation}>{p.menu}</div>
    <main className={main}>{p.children}</main>
  </div>
);
